var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c(
                "div",
                [
                  _vm.$checkPermission("TIMESLOTS")
                    ? _c("crud-button", {
                        attrs: {
                          "x-large": "",
                          color: "light-blue lighten-2",
                          icon: "fa-plus",
                          tooltip: _vm.$t("global.crud.button.add")
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.create()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: { sm: "4", lg: "2", xl: "2", cols: "12" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("timeSlots.name"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "name", $$v)
                                  },
                                  expression: "filter.name"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: { sm: "4", lg: "2", xl: "2", cols: "12" }
                            },
                            [
                              _c(
                                "v-dialog",
                                {
                                  ref: "dialogFilterTimeSlotFrom",
                                  attrs: {
                                    "return-value": _vm.filter.hourFromString,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "hourFromString",
                                        $event
                                      )
                                    },
                                    "update:return-value": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "hourFromString",
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "timeSlots.timeSlotFrom"
                                                  ),
                                                  readonly: "",
                                                  clearable: "",
                                                  "append-icon": "far fa-clock"
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter.hourFromString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "hourFromString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.hourFromString"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalFilterTimeSlotFrom,
                                    callback: function($$v) {
                                      _vm.modalFilterTimeSlotFrom = $$v
                                    },
                                    expression: "modalFilterTimeSlotFrom"
                                  }
                                },
                                [
                                  _vm.modalFilterTimeSlotFrom
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: {
                                            "full-width": "",
                                            format: "24hr",
                                            "allowed-minutes":
                                              _vm.allowedStepTime
                                          },
                                          on: {
                                            "click:minute": function($event) {
                                              return _vm.$refs.dialogFilterTimeSlotFrom.save(
                                                _vm.filter.hourFromString
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.filter.hourFromString,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filter,
                                                "hourFromString",
                                                $$v
                                              )
                                            },
                                            expression: "filter.hourFromString"
                                          }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.modalFilterTimeSlotFrom = false
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("global.cancel")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: { sm: "4", lg: "2", xl: "2", cols: "12" }
                            },
                            [
                              _c(
                                "v-dialog",
                                {
                                  ref: "dialogFilterTimeSlotTo",
                                  attrs: {
                                    "return-value": _vm.filter.hourToString,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "hourToString",
                                        $event
                                      )
                                    },
                                    "update:return-value": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "hourToString",
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "timeSlots.timeSlotTo"
                                                  ),
                                                  readonly: "",
                                                  clearable: "",
                                                  "append-icon": "far fa-clock"
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter.hourToString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "hourToString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.hourToString"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalFilterTimeSlotTo,
                                    callback: function($$v) {
                                      _vm.modalFilterTimeSlotTo = $$v
                                    },
                                    expression: "modalFilterTimeSlotTo"
                                  }
                                },
                                [
                                  _vm.modalFilterTimeSlotTo
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: {
                                            "full-width": "",
                                            format: "24hr",
                                            "allowed-minutes":
                                              _vm.allowedStepTime
                                          },
                                          on: {
                                            "click:minute": function($event) {
                                              return _vm.$refs.dialogFilterTimeSlotTo.save(
                                                _vm.filter.hourToString
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.filter.hourToString,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filter,
                                                "hourToString",
                                                $$v
                                              )
                                            },
                                            expression: "filter.hourToString"
                                          }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.modalFilterTimeSlotTo = false
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("global.cancel")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: { sm: "6", lg: "3", xl: "2", cols: "12" }
                            },
                            [
                              !_vm.$userIsAdmin()
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t("zones.agency"),
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.filter.agencyCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "agencyCode", $$v)
                                      },
                                      expression: "filter.agencyCode"
                                    }
                                  })
                                : _vm._e(),
                              _vm.$userIsAdmin()
                                ? _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.agenciesFilterItems,
                                      loading: _vm.agenciesFilter.isLoading,
                                      "search-input": _vm.agenciesFilter.search,
                                      "hide-no-data": "",
                                      "no-data-text": _vm.$t(
                                        "global.autocomplete.noDataFound"
                                      ),
                                      "item-text": "description",
                                      "item-value": "code",
                                      label: _vm.$t("timeSlots.agency"),
                                      placeholder: _vm.$t(
                                        "global.autocomplete.starTypingToSearch"
                                      ),
                                      clearable: ""
                                    },
                                    on: {
                                      "update:searchInput": function($event) {
                                        return _vm.$set(
                                          _vm.agenciesFilter,
                                          "search",
                                          $event
                                        )
                                      },
                                      "update:search-input": function($event) {
                                        return _vm.$set(
                                          _vm.agenciesFilter,
                                          "search",
                                          $event
                                        )
                                      },
                                      focus: function($event) {
                                        _vm.agenciesFilter.isEdit = true
                                      },
                                      change: function($event) {
                                        _vm.agenciesFilter.isEdit = false
                                      }
                                    },
                                    model: {
                                      value: _vm.filter.agencyCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "agencyCode", $$v)
                                      },
                                      expression: "filter.agencyCode"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: { sm: "6", lg: "3", xl: "2", cols: "12" }
                            },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.zonesFilterItems,
                                  loading: _vm.zonesFilter.isLoading,
                                  "search-input": _vm.zonesFilter.search,
                                  "hide-no-data": "",
                                  "no-data-text": _vm.$t(
                                    "global.autocomplete.noDataFound"
                                  ),
                                  "item-text": "description",
                                  "item-value": "code",
                                  label: _vm.$t("timeSlots.zone"),
                                  placeholder: _vm.$t(
                                    "global.autocomplete.starTypingToSearch"
                                  ),
                                  clearable: ""
                                },
                                on: {
                                  "update:searchInput": function($event) {
                                    return _vm.$set(
                                      _vm.zonesFilter,
                                      "search",
                                      $event
                                    )
                                  },
                                  "update:search-input": function($event) {
                                    return _vm.$set(
                                      _vm.zonesFilter,
                                      "search",
                                      $event
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.zonesFilter.isEdit = true
                                  },
                                  change: function($event) {
                                    _vm.zonesFilter.isEdit = false
                                  }
                                },
                                model: {
                                  value: _vm.filter.zoneCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "zoneCode", $$v)
                                  },
                                  expression: "filter.zoneCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: { sm: "6", lg: "3", xl: "2", cols: "12" }
                            },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      )
                                        return null
                                      _vm.modalFilterValidityDateTimeSlotFrom = false
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "timeSlots.validityDateFrom"
                                                  ),
                                                  "append-icon":
                                                    "far fa-calendar-alt",
                                                  readonly: "",
                                                  clearable: ""
                                                },
                                                on: {
                                                  "click:clear": function(
                                                    $event
                                                  ) {
                                                    _vm.filter.validityDateFrom = null
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter
                                                      .validityDateFromFormatted,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "validityDateFromFormatted",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.validityDateFromFormatted"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value:
                                      _vm.modalFilterValidityDateTimeSlotFrom,
                                    callback: function($$v) {
                                      _vm.modalFilterValidityDateTimeSlotFrom = $$v
                                    },
                                    expression:
                                      "modalFilterValidityDateTimeSlotFrom"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { scrollable: "" },
                                      on: {
                                        input: function($event) {
                                          _vm.modalFilterValidityDateTimeSlotFrom = false
                                        }
                                      },
                                      model: {
                                        value: _vm.filter.validityDateFrom,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter,
                                            "validityDateFrom",
                                            $$v
                                          )
                                        },
                                        expression: "filter.validityDateFrom"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.modalFilterValidityDateTimeSlotFrom = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.cancel")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: { sm: "6", lg: "3", xl: "2", cols: "12" }
                            },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      )
                                        return null
                                      _vm.modalFilterValidityDateTimeSlotTo = false
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "timeSlots.validityDateTo"
                                                  ),
                                                  "append-icon":
                                                    "far fa-calendar-alt",
                                                  readonly: "",
                                                  clearable: ""
                                                },
                                                on: {
                                                  "click:clear": function(
                                                    $event
                                                  ) {
                                                    _vm.filter.validityDateTo = null
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter
                                                      .validityDateToFormatted,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "validityDateToFormatted",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.validityDateToFormatted"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value:
                                      _vm.modalFilterValidityDateTimeSlotTo,
                                    callback: function($$v) {
                                      _vm.modalFilterValidityDateTimeSlotTo = $$v
                                    },
                                    expression:
                                      "modalFilterValidityDateTimeSlotTo"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { scrollable: "" },
                                      on: {
                                        input: function($event) {
                                          _vm.modalFilterValidityDateTimeSlotTo = false
                                        }
                                      },
                                      model: {
                                        value: _vm.filter.validityDateTo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter,
                                            "validityDateTo",
                                            $$v
                                          )
                                        },
                                        expression: "filter.validityDateTo"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.modalFilterValidityDateTimeSlotTo = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.cancel")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: { sm: "6", lg: "2", xl: "1", cols: "12" }
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.currentlyInForceValues,
                                  label: _vm.$t("timeSlots.currentlyInForce")
                                },
                                model: {
                                  value: _vm.filter.currentlyInForce,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filter,
                                      "currentlyInForce",
                                      $$v
                                    )
                                  },
                                  expression: "filter.currentlyInForce"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: { sm: "6", lg: "2", xl: "1", cols: "12" }
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.deletedItemsValues,
                                  label: _vm.$t("global.status")
                                },
                                model: {
                                  value: _vm.filter.deletedItems,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "deletedItems", $$v)
                                  },
                                  expression: "filter.deletedItems"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                sm: "6",
                                lg: "2",
                                xl: "1",
                                cols: "12",
                                "align-self": "center"
                              }
                            },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    "max-height": "50vh",
                                    "offset-y": ""
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "mb-3",
                                                attrs: {
                                                  block: "",
                                                  outlined: ""
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("timeSlots.weekdays")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c(
                                    "v-list",
                                    { attrs: { tile: "", shaped: "" } },
                                    [
                                      _c(
                                        "v-list-item",
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              "hide-details": "",
                                              label: _vm.$t("timeSlots.monday")
                                            },
                                            model: {
                                              value: _vm.filter.monday,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filter,
                                                  "monday",
                                                  $$v
                                                )
                                              },
                                              expression: "filter.monday"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              "hide-details": "",
                                              label: _vm.$t("timeSlots.tuesday")
                                            },
                                            model: {
                                              value: _vm.filter.tuesday,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filter,
                                                  "tuesday",
                                                  $$v
                                                )
                                              },
                                              expression: "filter.tuesday"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              "hide-details": "",
                                              label: _vm.$t(
                                                "timeSlots.wednesday"
                                              )
                                            },
                                            model: {
                                              value: _vm.filter.wednesday,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filter,
                                                  "wednesday",
                                                  $$v
                                                )
                                              },
                                              expression: "filter.wednesday"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              "hide-details": "",
                                              label: _vm.$t(
                                                "timeSlots.thursday"
                                              )
                                            },
                                            model: {
                                              value: _vm.filter.thursday,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filter,
                                                  "thursday",
                                                  $$v
                                                )
                                              },
                                              expression: "filter.thursday"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              "hide-details": "",
                                              label: _vm.$t("timeSlots.friday")
                                            },
                                            model: {
                                              value: _vm.filter.friday,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filter,
                                                  "friday",
                                                  $$v
                                                )
                                              },
                                              expression: "filter.friday"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              "hide-details": "",
                                              label: _vm.$t(
                                                "timeSlots.saturday"
                                              )
                                            },
                                            model: {
                                              value: _vm.filter.saturday,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filter,
                                                  "saturday",
                                                  $$v
                                                )
                                              },
                                              expression: "filter.saturday"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              "hide-details": "",
                                              label: _vm.$t("timeSlots.sunday")
                                            },
                                            model: {
                                              value: _vm.filter.sunday,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filter,
                                                  "sunday",
                                                  $$v
                                                )
                                              },
                                              expression: "filter.sunday"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.refreshItemsView()
                      }
                    }
                  })
                ],
                1
              ),
              _c("ExportExcel", {
                attrs: {
                  url: "/timeSlots",
                  filter: this.filter,
                  filterExport: _vm.filterExport
                }
              }),
              _vm.$checkPermission("TIMESLOTS")
                ? _c("ImportExcel", {
                    attrs: {
                      url: "/timeSlots",
                      filterImport: _vm.filterImport
                    },
                    on: { done: _vm.search }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                "item-key": "code",
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ items }) {
                    return [
                      _c(
                        "tbody",
                        _vm._l(items, function(item) {
                          return _c("tr", { key: item.code }, [
                            _c(
                              "td",
                              [
                                _vm.$checkPermission("TIMESLOTS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "orange",
                                        icon: "fa-pen",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.edit"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.edit(item.code)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                (item.deletionDate === undefined ||
                                  item.deletionDate === null) &&
                                _vm.$checkPermission("TIMESLOTS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "red",
                                        icon: "fa-trash",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.delete"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.suspend(item.code)
                                        }
                                      }
                                    })
                                  : _vm.$checkPermission("TIMESLOTS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "green",
                                        icon: "fa-redo",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.restore"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.restore(item.code)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { right: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function({ on }) {
                                            return [
                                              _c("span", _vm._g({}, on), [
                                                _vm._v(_vm._s(item.agency.code))
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(item.agency.name))
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { right: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function({ on }) {
                                            return [
                                              _c("span", _vm._g({}, on), [
                                                _vm._v(_vm._s(item.zone.code))
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [_c("span", [_vm._v(_vm._s(item.zone.name))])]
                                )
                              ],
                              1
                            ),
                            _c("td", [_vm._v(_vm._s(item.name))]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.minutesToHour(item.hourFrom)) +
                                  " - " +
                                  _vm._s(_vm.minutesToHour(item.hourTo)) +
                                  " "
                              )
                            ]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.transformDate(
                                      item.validityDateFrom,
                                      _vm.$t("global.dateFormat")
                                    )
                                  ) +
                                  " - " +
                                  _vm._s(
                                    _vm.transformDate(
                                      item.validityDateTo,
                                      _vm.$t("global.dateFormat")
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.minutesFormat(item.avalibleDeliveryTime)
                                  ) +
                                  " "
                              )
                            ]),
                            _c(
                              "td",
                              [
                                _c("BooleanToIcon", {
                                  attrs: { value: item.monday }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c("BooleanToIcon", {
                                  attrs: { value: item.tuesday }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c("BooleanToIcon", {
                                  attrs: { value: item.wednesday }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c("BooleanToIcon", {
                                  attrs: { value: item.thursday }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c("BooleanToIcon", {
                                  attrs: { value: item.friday }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c("BooleanToIcon", {
                                  attrs: { value: item.saturday }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c("BooleanToIcon", {
                                  attrs: { value: item.sunday }
                                })
                              ],
                              1
                            )
                          ])
                        }),
                        0
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            "no-click-animation": ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("validation-observer", {
            ref: "obs",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ invalid, validated, passes }) {
                  return [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              dark: "",
                              color: "primary",
                              dense: "",
                              flat: ""
                            }
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              { staticClass: "white--text" },
                              [_vm._v(" " + _vm._s(_vm.formTitle) + " ")]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("fas fa-times")])],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "details-list" },
                          [
                            _c(
                              "v-form",
                              [
                                _c(
                                  "v-container",
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t("timeSlots.name"),
                                                rules: "required|max:60"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "timeSlots.name"
                                                            ),
                                                            required: "",
                                                            "error-messages": errors,
                                                            counter: "60"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item.name,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "name",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.name"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c(
                                              "v-dialog",
                                              {
                                                attrs: {
                                                  "close-on-content-click": false,
                                                  persistent: "",
                                                  width: "290px"
                                                },
                                                on: {
                                                  keydown: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "esc",
                                                        27,
                                                        $event.key,
                                                        ["Esc", "Escape"]
                                                      )
                                                    )
                                                      return null
                                                    _vm.modalValidityDateTimeSlotFrom = false
                                                  }
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function({ on }) {
                                                        return [
                                                          _c(
                                                            "validation-provider",
                                                            {
                                                              attrs: {
                                                                name: _vm.$t(
                                                                  "timeSlots.validityDateFrom"
                                                                ),
                                                                rules:
                                                                  "required",
                                                                vid:
                                                                  "fieldValidityDateFrom"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function({
                                                                      errors
                                                                    }) {
                                                                      return [
                                                                        _c(
                                                                          "v-text-field",
                                                                          _vm._g(
                                                                            {
                                                                              attrs: {
                                                                                label: _vm.$t(
                                                                                  "timeSlots.validityDateFrom"
                                                                                ),
                                                                                "append-icon":
                                                                                  "far fa-calendar-alt",
                                                                                readonly:
                                                                                  "",
                                                                                required:
                                                                                  "",
                                                                                clearable:
                                                                                  "",
                                                                                "error-messages": errors
                                                                              },
                                                                              on: {
                                                                                "click:clear": function(
                                                                                  $event
                                                                                ) {
                                                                                  _vm.item.validityDateFrom = null
                                                                                }
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  _vm
                                                                                    .item
                                                                                    .validityDateFromFormatted,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.item,
                                                                                    "validityDateFromFormatted",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.validityDateFromFormatted"
                                                                              }
                                                                            },
                                                                            on
                                                                          )
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value:
                                                    _vm.modalValidityDateTimeSlotFrom,
                                                  callback: function($$v) {
                                                    _vm.modalValidityDateTimeSlotFrom = $$v
                                                  },
                                                  expression:
                                                    "modalValidityDateTimeSlotFrom"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-date-picker",
                                                  {
                                                    attrs: { scrollable: "" },
                                                    on: {
                                                      input: function($event) {
                                                        _vm.modalValidityDateTimeSlotFrom = false
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.item
                                                          .validityDateFrom,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.item,
                                                          "validityDateFrom",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.validityDateFrom"
                                                    }
                                                  },
                                                  [
                                                    _c("v-spacer"),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          text: "",
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.modalValidityDateTimeSlotFrom = false
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "global.cancel"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          [
                                            _c(
                                              "v-dialog",
                                              {
                                                attrs: {
                                                  "close-on-content-click": false,
                                                  persistent: "",
                                                  width: "290px"
                                                },
                                                on: {
                                                  keydown: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "esc",
                                                        27,
                                                        $event.key,
                                                        ["Esc", "Escape"]
                                                      )
                                                    )
                                                      return null
                                                    _vm.modalValidityDateTimeSlotTo = false
                                                  }
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function({ on }) {
                                                        return [
                                                          _c(
                                                            "v-text-field",
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  label: _vm.$t(
                                                                    "timeSlots.validityDateTo"
                                                                  ),
                                                                  "append-icon":
                                                                    "far fa-calendar-alt",
                                                                  readonly: "",
                                                                  clearable: ""
                                                                },
                                                                on: {
                                                                  "click:clear": function(
                                                                    $event
                                                                  ) {
                                                                    _vm.item.validityDateTo = null
                                                                  }
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.item
                                                                      .validityDateToFormatted,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.item,
                                                                      "validityDateToFormatted",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "item.validityDateToFormatted"
                                                                }
                                                              },
                                                              on
                                                            )
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value:
                                                    _vm.modalValidityDateTimeSlotTo,
                                                  callback: function($$v) {
                                                    _vm.modalValidityDateTimeSlotTo = $$v
                                                  },
                                                  expression:
                                                    "modalValidityDateTimeSlotTo"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-date-picker",
                                                  {
                                                    attrs: { scrollable: "" },
                                                    on: {
                                                      input: function($event) {
                                                        _vm.modalValidityDateTimeSlotTo = false
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.item.validityDateTo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.item,
                                                          "validityDateTo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.validityDateTo"
                                                    }
                                                  },
                                                  [
                                                    _c("v-spacer"),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          text: "",
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.modalValidityDateTimeSlotTo = false
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "global.cancel"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c(
                                              "v-dialog",
                                              {
                                                ref: "dialogTimeSlotFrom",
                                                attrs: {
                                                  "return-value":
                                                    _vm.item.hourFromString,
                                                  persistent: "",
                                                  width: "290px"
                                                },
                                                on: {
                                                  "update:returnValue": function(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.item,
                                                      "hourFromString",
                                                      $event
                                                    )
                                                  },
                                                  "update:return-value": function(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.item,
                                                      "hourFromString",
                                                      $event
                                                    )
                                                  }
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function({ on }) {
                                                        return [
                                                          _c(
                                                            "validation-provider",
                                                            {
                                                              attrs: {
                                                                name: _vm.$t(
                                                                  "timeSlots.timeSlotFrom"
                                                                ),
                                                                rules:
                                                                  "required",
                                                                vid:
                                                                  "fieldTimeSlotFrom"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function({
                                                                      errors
                                                                    }) {
                                                                      return [
                                                                        _c(
                                                                          "v-text-field",
                                                                          _vm._g(
                                                                            {
                                                                              attrs: {
                                                                                label: _vm.$t(
                                                                                  "timeSlots.timeSlotFrom"
                                                                                ),
                                                                                readonly:
                                                                                  "",
                                                                                required:
                                                                                  "",
                                                                                "append-icon":
                                                                                  "far fa-clock",
                                                                                "error-messages": errors
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  _vm
                                                                                    .item
                                                                                    .hourFromString,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.item,
                                                                                    "hourFromString",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.hourFromString"
                                                                              }
                                                                            },
                                                                            on
                                                                          )
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value: _vm.modalTimeSlotFrom,
                                                  callback: function($$v) {
                                                    _vm.modalTimeSlotFrom = $$v
                                                  },
                                                  expression:
                                                    "modalTimeSlotFrom"
                                                }
                                              },
                                              [
                                                _vm.modalTimeSlotFrom
                                                  ? _c(
                                                      "v-time-picker",
                                                      {
                                                        attrs: {
                                                          "full-width": "",
                                                          format: "24hr",
                                                          "allowed-minutes":
                                                            _vm.allowedStepTime
                                                        },
                                                        on: {
                                                          "click:minute": function(
                                                            $event
                                                          ) {
                                                            return _vm.$refs.dialogTimeSlotFrom.save(
                                                              _vm.item
                                                                .hourFromString
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.item
                                                              .hourFromString,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.item,
                                                              "hourFromString",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.hourFromString"
                                                        }
                                                      },
                                                      [
                                                        _c("v-spacer"),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              text: "",
                                                              color: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.modalTimeSlotFrom = false
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "global.cancel"
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              text: "",
                                                              color: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.$refs.dialogTimeSlotFrom.save(
                                                                  _vm.item
                                                                    .hourFromString
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "global.confirm"
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          [
                                            _c(
                                              "v-dialog",
                                              {
                                                ref: "dialogTimeSlotTo",
                                                attrs: {
                                                  "return-value":
                                                    _vm.item.hourToString,
                                                  persistent: "",
                                                  width: "290px"
                                                },
                                                on: {
                                                  "update:returnValue": function(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.item,
                                                      "hourToString",
                                                      $event
                                                    )
                                                  },
                                                  "update:return-value": function(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.item,
                                                      "hourToString",
                                                      $event
                                                    )
                                                  }
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function({ on }) {
                                                        return [
                                                          _c(
                                                            "validation-provider",
                                                            {
                                                              attrs: {
                                                                name: _vm.$t(
                                                                  "timeSlots.timeSlotTo"
                                                                ),
                                                                rules:
                                                                  "required|hourBefore:@fieldTimeSlotFrom",
                                                                vid:
                                                                  "fieldTimeSlotTo"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function({
                                                                      errors
                                                                    }) {
                                                                      return [
                                                                        _c(
                                                                          "v-text-field",
                                                                          _vm._g(
                                                                            {
                                                                              attrs: {
                                                                                label: _vm.$t(
                                                                                  "timeSlots.timeSlotTo"
                                                                                ),
                                                                                readonly:
                                                                                  "",
                                                                                required:
                                                                                  "",
                                                                                "append-icon":
                                                                                  "far fa-clock",
                                                                                "error-messages": errors
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  _vm
                                                                                    .item
                                                                                    .hourToString,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.item,
                                                                                    "hourToString",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.hourToString"
                                                                              }
                                                                            },
                                                                            on
                                                                          )
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value: _vm.modalTimeSlotTo,
                                                  callback: function($$v) {
                                                    _vm.modalTimeSlotTo = $$v
                                                  },
                                                  expression: "modalTimeSlotTo"
                                                }
                                              },
                                              [
                                                _vm.modalTimeSlotTo
                                                  ? _c(
                                                      "v-time-picker",
                                                      {
                                                        attrs: {
                                                          "full-width": "",
                                                          format: "24hr",
                                                          "allowed-minutes":
                                                            _vm.allowedStepTime
                                                        },
                                                        on: {
                                                          "click:minute": function(
                                                            $event
                                                          ) {
                                                            return _vm.$refs.dialogTimeSlotTo.save(
                                                              _vm.item
                                                                .hourToString
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.item
                                                              .hourToString,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.item,
                                                              "hourToString",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.hourToString"
                                                        }
                                                      },
                                                      [
                                                        _c("v-spacer"),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              text: "",
                                                              color: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.modalTimeSlotTo = false
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "global.cancel"
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              text: "",
                                                              color: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.$refs.dialogTimeSlotTo.save(
                                                                  _vm.item
                                                                    .hourToString
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "global.confirm"
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "timeSlots.avalibleDeliveryTime"
                                                ),
                                                rules: "required|max:5"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "timeSlots.avalibleDeliveryTime"
                                                            ),
                                                            required: "",
                                                            "error-messages": errors
                                                          },
                                                          on: {
                                                            keypress: function(
                                                              $event
                                                            ) {
                                                              return _vm.integerOnlyField(
                                                                $event
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item
                                                                .avalibleDeliveryTime,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "avalibleDeliveryTime",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.avalibleDeliveryTime"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "timeSlots.resourceNumberWeight"
                                                ),
                                                rules: "decimal:7,4"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "timeSlots.resourceNumberWeight"
                                                            ),
                                                            type: "number",
                                                            "error-messages": errors
                                                          },
                                                          on: {
                                                            keypress: function(
                                                              $event
                                                            ) {
                                                              return _vm.decimalOnlyField(
                                                                $event
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item
                                                                .resourceNumberWeight,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "resourceNumberWeight",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.resourceNumberWeight"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "timeSlots.resourceNumberVolumen"
                                                ),
                                                rules: "decimal:5,4"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "timeSlots.resourceNumberVolumen"
                                                            ),
                                                            type: "number",
                                                            "error-messages": errors
                                                          },
                                                          on: {
                                                            keypress: function(
                                                              $event
                                                            ) {
                                                              return _vm.decimalOnlyField(
                                                                $event
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item
                                                                .resourceNumberVolumen,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "resourceNumberVolumen",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.resourceNumberVolumen"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "timeSlots.resourceNumberSlots"
                                                ),
                                                rules: "integer|max:10"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "timeSlots.resourceNumberSlots"
                                                            ),
                                                            type: "number",
                                                            "error-messages": errors
                                                          },
                                                          on: {
                                                            keypress: function(
                                                              $event
                                                            ) {
                                                              return _vm.integerOnlyField(
                                                                $event
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item
                                                                .resourceNumberSlots,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "resourceNumberSlots",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.resourceNumberSlots"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { align: "center" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("timeSlots.monday")
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { align: "center" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("timeSlots.tuesday")
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { align: "center" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("timeSlots.wednesday")
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { align: "center" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("timeSlots.thursday")
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { align: "center" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("timeSlots.friday")
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { align: "center" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("timeSlots.saturday")
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { align: "center" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("timeSlots.sunday")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-inline-flex justify-center"
                                          },
                                          [
                                            _c("v-switch", {
                                              staticClass: "ml-2",
                                              model: {
                                                value: _vm.item.monday,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "monday",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.monday"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-inline-flex justify-center"
                                          },
                                          [
                                            _c("v-switch", {
                                              staticClass: "ml-2",
                                              model: {
                                                value: _vm.item.tuesday,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "tuesday",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.tuesday"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-inline-flex justify-center"
                                          },
                                          [
                                            _c("v-switch", {
                                              staticClass: "ml-2",
                                              model: {
                                                value: _vm.item.wednesday,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "wednesday",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.wednesday"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-inline-flex justify-center"
                                          },
                                          [
                                            _c("v-switch", {
                                              staticClass: "ml-2",
                                              model: {
                                                value: _vm.item.thursday,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "thursday",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.thursday"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-inline-flex justify-center"
                                          },
                                          [
                                            _c("v-switch", {
                                              staticClass: "ml-2",
                                              model: {
                                                value: _vm.item.friday,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "friday",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.friday"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-inline-flex justify-center"
                                          },
                                          [
                                            _c("v-switch", {
                                              staticClass: "ml-2",
                                              model: {
                                                value: _vm.item.saturday,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "saturday",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.saturday"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-inline-flex justify-center"
                                          },
                                          [
                                            _c("v-switch", {
                                              staticClass: "ml-2",
                                              model: {
                                                value: _vm.item.sunday,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "sunday",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.sunday"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            !_vm.editMode
                                              ? _c("validation-provider", {
                                                  attrs: {
                                                    name: _vm.$t(
                                                      "timeSlots.agency"
                                                    ),
                                                    rules: "required"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function({
                                                          errors
                                                        }) {
                                                          return [
                                                            !_vm.$userIsAdmin()
                                                              ? _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label: _vm.$t(
                                                                        "zones.agency"
                                                                      ),
                                                                      disabled:
                                                                        ""
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.item
                                                                          .agencyCode,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.item,
                                                                          "agencyCode",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "item.agencyCode"
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _vm.$userIsAdmin()
                                                              ? _c(
                                                                  "v-autocomplete",
                                                                  {
                                                                    attrs: {
                                                                      items:
                                                                        _vm.agenciesItems,
                                                                      loading:
                                                                        _vm
                                                                          .agencies
                                                                          .isLoading,
                                                                      "search-input":
                                                                        _vm
                                                                          .agencies
                                                                          .search,
                                                                      "hide-no-data":
                                                                        "",
                                                                      "no-data-text": _vm.$t(
                                                                        "global.autocomplete.noDataFound"
                                                                      ),
                                                                      "item-text":
                                                                        "description",
                                                                      "item-value":
                                                                        "code",
                                                                      label: _vm.$t(
                                                                        "timeSlots.agency"
                                                                      ),
                                                                      placeholder: _vm.$t(
                                                                        "global.autocomplete.starTypingToSearch"
                                                                      ),
                                                                      "error-messages": errors,
                                                                      clearable:
                                                                        ""
                                                                    },
                                                                    on: {
                                                                      "update:searchInput": function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.agencies,
                                                                          "search",
                                                                          $event
                                                                        )
                                                                      },
                                                                      "update:search-input": function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.agencies,
                                                                          "search",
                                                                          $event
                                                                        )
                                                                      },
                                                                      focus: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.agencies.isEdit = true
                                                                      },
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.agencies.isEdit = false
                                                                        _vm.resetZonesSearch()
                                                                      }
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.item
                                                                          .agencyCode,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.item,
                                                                          "agencyCode",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "item.agencyCode"
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              : _c("v-text-field", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "timeSlots.agency"
                                                    ),
                                                    disabled: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.item.agencyString,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.item,
                                                        "agencyString",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.agencyString"
                                                  }
                                                })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            !_vm.editMode
                                              ? _c("validation-provider", {
                                                  attrs: {
                                                    name: _vm.$t(
                                                      "timeSlots.zone"
                                                    ),
                                                    rules: "required"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function({
                                                          errors
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-autocomplete",
                                                              {
                                                                attrs: {
                                                                  items:
                                                                    _vm.zonesItems,
                                                                  loading:
                                                                    _vm.zones
                                                                      .isLoading,
                                                                  "search-input":
                                                                    _vm.zones
                                                                      .search,
                                                                  "hide-no-data":
                                                                    "",
                                                                  disabled:
                                                                    _vm.isAgencySelected,
                                                                  "no-data-text": _vm.$t(
                                                                    "global.autocomplete.noDataFound"
                                                                  ),
                                                                  "item-text":
                                                                    "description",
                                                                  "item-value":
                                                                    "code",
                                                                  label: _vm.$t(
                                                                    "timeSlots.zone"
                                                                  ),
                                                                  placeholder: _vm.$t(
                                                                    "global.autocomplete.starTypingToSearch"
                                                                  ),
                                                                  "error-messages": errors,
                                                                  clearable: ""
                                                                },
                                                                on: {
                                                                  "update:searchInput": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      _vm.zones,
                                                                      "search",
                                                                      $event
                                                                    )
                                                                  },
                                                                  "update:search-input": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      _vm.zones,
                                                                      "search",
                                                                      $event
                                                                    )
                                                                  },
                                                                  focus: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.zones.isEdit = true
                                                                  },
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.zones.isEdit = false
                                                                  }
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.item
                                                                      .zoneCode,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.item,
                                                                      "zoneCode",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "item.zoneCode"
                                                                }
                                                              }
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              : _c("v-text-field", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "timeSlots.zone"
                                                    ),
                                                    disabled: ""
                                                  },
                                                  model: {
                                                    value: _vm.item.zoneString,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.item,
                                                        "zoneString",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.zoneString"
                                                  }
                                                })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "black", text: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.buttons.close")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.editMode
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "orange", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.update)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.update")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "green", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.save)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.create")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }